export class ValidationResult {
  get isValid(): boolean {
    return this.errors.length === 0;
  }
  errors: ValidationError[] = [];
}

export class ValidationError {
  entityId?: string;
  entityName?: string;
  propertyName!: string;
  errorMessage!: string;
  severity!: 0 | 1 | 2; // 0 = Error, 1 = Warning, 2 = Info
}
